import translate from "../../../common/Dictionary";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import ShortNotice from '../ShortNotice';
import errorFill from "../../../../img/icon_fill_error.svg";

const StepFour = ({ 
    state, 
    userData, 
    setState, 
    handleGSMInput,
    handleGSMBlur,
    handleLastNameInput,
    handleLastNameBlur,
    handleFirstNameInput,
    handleFirstNameBlur,
    handleEmailInput,
    handleEmailBlur,
    createProject,
    errorDivRef,
    onBack,
    onPrivacyClick
}) => {
    return (
        <div className="axa-project-card">
            <div className="axa-subcat-card-padding axa-card-shadow mt-4 bg-white" >
                <div className="axa-mobile-hidden" style={{ "height": "32px" }}></div>
                <ShortNotice />
                <div className="axa-service-card-title align-left pt-5 pb-5">{translate("newProjectCustomerInfoHeader", userData.language)}</div>
                <hr className="axa-service-card-diveder" />
                <div className="axa-error-box" style={{ display: (state.showErrorDiv ? "" : "none") }} ref={errorDivRef}>
                    <div className="p-3" align="left">
                        <div className="d-flex gap-3">
                            <div>
                                <img src={errorFill} alt="error icon" />
                            </div>
                            <div className="flex-fill">
                                <div className="axa-success-box-header pt-1">
                                    {translate("newProjectCustomerInfoErrorDivHeader", userData.language)}
                                </div>
                                <div className="py-2">
                                    <ul>
                                        <li style={{ display: (state.errorLastName ? "" : "none") }}>
                                            {translate("newProjectCustomerInfoErrorDivLastName", userData.language)}
                                        </li>
                                        <li style={{ display: (state.errorFirstName ? "" : "none") }}>
                                            {translate("newProjectCustomerInfoErrorDivFirsName", userData.language)}
                                        </li>
                                        <li style={{ display: (state.errorGsm ? "" : "none") }}>
                                            {translate("newProjectCustomerInfoErrorDivGsm", userData.language)}
                                        </li>
                                        <li style={{ display: (state.errorEmail ? "" : "none") }}>
                                            {translate("newProjectCustomerInfoErrorDivEmail", userData.language)}
                                        </li>
                                        <li style={{ display: (state.errorPrivacy ? "" : "none") }}>
                                            {translate("newProjectCustomerInfoErrorDivPrivacy", userData.language)}
                                        </li>
                                        <li style={{ display: (state.errorCustomerAddressStreetAndHouse ? "" : "none") }}>
                                            {translate("newProjectCustomerInfoErrorDivCustomerAddress", userData.language)}
                                        </li>
                                        <li style={{ display: (state.errorCustomerIsAxaCustomer ? "" : "none") }}>
                                            {translate("newProjectCustomerInfoErrorDivCustomerIsAxaCustomer", userData.language)}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="axa-newproject-second-title align-left pt-4 pb-4">{translate("newProjectCustomerInfoSecondaryTitleContact", userData.language)}</div>
                <div className="axa-input-label align-left">{translate("newProjectCustomerInfoLabelAxaCustomer", userData.language)}</div>
                <div className="row mt-2 gap-1" align="left">
                    <div className="col-md-3 col-sm-6 d-grid" align="left">
                        <input type="radio" className="btn-check" name="optionsAxaCustomer" id="rdbAxaCustomerYes" value={true} onChange={(event) => setState({ ...state, customerIsAxaCustomer: event.target.value })} />
                        <label className="btn btn-outline-primary" htmlFor="rdbAxaCustomerYes">{translate("newProjectCustomerInfoBtnAxaCustomerYes", userData.language)}</label>
                    </div>
                    <div className="col-md-3 col-sm-6 d-grid" align="left">
                        <input type="radio" className="btn-check" name="optionsAxaCustomer" id="rdbAxaCustomerNo" value={false} onChange={(event) => setState({ ...state, customerIsAxaCustomer: event.target.value })} />
                        <label className="btn btn-outline-primary" htmlFor="rdbAxaCustomerNo">{translate("newProjectCustomerInfoBtnAxaCustomerNo", userData.language)}</label>
                    </div>
                </div>
                <div className="axa-input-label align-left mt-4">
                    <label htmlFor="textbox-customer-last-name">{translate("newProjectCustomerInfoLabelLastName", userData.language)}</label>
                </div>
                <div className="row mt-1" align="left">
                    <div className="col-md-7 col-sm-12 d-grid" align="left">
                        <input
                            id="textbox-customer-last-name"
                            type="text"
                            className={"form-control " + (state.errorLastName ? "border-danger" : "")}
                            onChange={(event) => handleLastNameInput(event)}
                            onBlur={(event) => handleLastNameBlur(event)}
                            value={state.customerLastName}
                        />
                    </div>
                </div>
                <div className="text-danger" style={{ display: (state.errorLastName ? "" : "none") }} align="left">{translate("newProjectCustomerInfoErrorLastName", userData.language)}</div>
                <div className="axa-input-label align-left mt-4">
                    <label htmlFor="textbox-customer-name">{translate("newProjectCustomerInfoLabelFirstName", userData.language)}</label>
                </div>
                <div className="row mt-1" align="left">
                    <div className="col-md-7 col-sm-12 d-grid" align="left">
                        <input
                            id="textbox-customer-name"
                            type="text"
                            className={"form-control " + (state.errorFirstName ? "border-danger" : "")}
                            onChange={(event) => handleFirstNameInput(event)}
                            onBlur={(event) => handleFirstNameBlur(event)}
                            value={state.customerFirstName}
                        />
                    </div>
                </div>
                <div className="text-danger" style={{ display: (state.errorFirstName ? "" : "none") }} align="left">{translate("newProjectCustomerInfoErrorFirstName", userData.language)}</div>
                <div className="axa-input-label align-left mt-4">
                    <label htmlFor="textbox-customer-gsm">{translate("newProjectCustomerInfoLabelGsmNumber", userData.language)}</label>
                </div>
                <div className="row mt-1" align="left">
                    <div className="col-md-7 col-sm-12 d-grid" align="left">
                        <input
                            id="textbox-customer-gsm"
                            type="text"
                            className={"form-control " + (state.errorGsm ? "border-danger" : "")}
                            onChange={(event) => handleGSMInput(event)}
                            onBlur={(event) => handleGSMBlur(event)}
                            value={state.customerGsmNumber}
                        />
                    </div>
                </div>
                <div className="text-danger" style={{ display: (state.errorGsm ? "" : "none") }} align="left">{translate("newProjectCustomerInfoErrorGsmNumber", userData.language)}</div>
                <div align="left" className={(state.errorGsm ? "text-danger" : "")}>{translate("newProjectCustomerInfoSecondaryLabelGsmNumberExample", userData.language)}</div>
                <div className="axa-input-label align-left mt-4">
                    <label htmlFor="textbox-customer-email">{translate("newProjectCustomerInfoLabelEmail", userData.language)}</label>
                </div>
                <div className="row mt-1" align="left">
                    <div className="col-md-7 col-sm-12 d-grid" align="left">
                        <input
                            id="textbox-customer-email"
                            type="text"
                            className={"form-control " + (state.errorEmail ? "border-danger" : "")}
                            onChange={(event) => handleEmailInput(event)}
                            onBlur={(event) => handleEmailBlur(event)}
                            value={state.customerEmail}
                        />
                    </div>
                </div>
                <div className="text-danger" style={{ display: (state.errorEmail ? "" : "none") }} align="left">{translate("newProjectCustomerInfoErrorEmail", userData.language)}</div>
                <div align="left" className={(state.errorEmail ? "text-danger" : "")}>{translate("newProjectCustomerInfoSecondaryLabelEmailExample", userData.language)}</div>
                <hr className="axa-service-card-diveder mt-7" />
                <div className="axa-newproject-second-title align-left pt-4 pb-4">{translate("newProjectCustomerInfoSecondaryTitleAddress", userData.language)}</div>
                <div className="axa-input-label align-left">
                    <label htmlFor="textbox-customer-street-and-home-address">{translate("newProjectCustomerInfoLabelStreetAndHouse", userData.language)}</label>
                </div>
                <div className="row mt-1" align="left">
                    <div className="col-md-7 col-sm-12 d-grid" align="left">
                        <input
                            id="textbox-customer-street-and-home-address"
                            type="text"
                            className={"form-control " + (state.errorCustomerAddressStreetAndHouse ? "border-danger" : "")}
                            onChange={(event) => setState({ ...state, customerAddressStreetAndHouse: event.target.value, errorCustomerAddressStreetAndHouse: event.target.value ? false : true })}
                            onBlur={(event) => setState({ ...state, errorCustomerAddressStreetAndHouse: event.target.value? false : true })}
                            value={state.customerAddressStreetAndHouse}
                        />
                    </div>
                </div>
                <div className="text-danger" style={{ display: (state.errorCustomerAddressStreetAndHouse ? "" : "none") }} align="left">{translate("newProjectCustomerInfoErrorCustomerAddress", userData.language)}</div>
                <div align="left" className="mt-4">
                    <span className="axa-input-label align-left">
                        <label htmlFor="textbox-customer-bus">{translate("newProjectCustomerInfoLabelBusStation", userData.language)}</label>
                    </span>
                    <span> {translate("newProjectDetailsLabelOptional", userData.language)}</span>
                </div>
                <div className="row mt-1" align="left">
                    <div className="col-md-3 col-sm-12 d-grid" align="left">
                        <input
                            id="textbox-customer-bus"
                            type="text"
                            className="form-control"
                            onChange={(event) => setState({ ...state, customerAddressBusStation: event.target.value })}
                            value={state.customerAddressBusStation}
                        />
                    </div>
                </div>
                <div className="axa-input-label align-left mt-4">
                    <label htmlFor="textbox-customer-selected-city">{translate("newProjectCustomerInfoLabelCity", userData.language)}</label>
                </div>
                <div className="row mt-1" align="left">
                    <div className="col-md-7 col-sm-12 d-grid" align="left">
                        <input
                            id="textbox-customer-selected-city"
                            type="text"
                            className="form-control"
                            value={state.customerAddressCity}
                            disabled
                        />
                    </div>
                </div>
                <div className="axa-input-label align-left mt-4">
                    <label htmlFor="textbox-customer-selected-potal-code">{translate("newProjectCustomerInfoLabelPostalCode", userData.language)}</label>
                </div>
                <div className="row mt-1" align="left">
                    <div className="col-md-3 col-sm-12 d-grid" align="left">
                        <input
                            id="textbox-customer-selected-potal-code"
                            type="text"
                            className="form-control"
                            value={state.checkPostalCode}
                            disabled
                        />
                    </div>
                </div>
                <div className="form-check mt-5" align="left">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        checked={state.customerPrivacyAccepted}
                        onChange={(event) => setState({ ...state, customerPrivacyAccepted: event.target.checked })}
                        id="chkPrivacy"
                    />
                    <label className="form-check-label" htmlFor="chkPrivacy">
                        {translate("newProjectPrivacyBeforeLink", userData.language) + " "}
                        <button
                            className="bg-white border-0 btn-link p-0"
                            onClick={onPrivacyClick}
                        >
                            <span style={{"textDecoration" : "underline"} }>{translate("newProjectPrivacyLink", userData.language)}</span>
                        </button>
                        {translate("newProjectPrivacyAfterLink", userData.language)}
                    </label>
                </div>
                <div className="form-check mt-3" align="left">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        checked={state.customerPrivacyMarketing}
                        onChange={(event) => setState({ ...state, customerPrivacyMarketing: event.target.checked })}
                        id="chkMarketing"
                    />
                    <label className="form-check-label" htmlFor="chkMarketing">
                        {translate("newProjectMarketingAccept", userData.language)}
                    </label>
                </div>
            </div>
            <div className={"d-flex flex-column-reverse flex-md-row pt-4 " + (state.checkProviderResult === "not-found" ? "justify-content-end" : "justify-content-between")}>
                <button
                    className="btn text-secondary"
                    onClick={onBack}
                >
                    <FontAwesomeIcon className="me-1" icon={faArrowLeft} />
                    {translate("newProjectBack", userData.language)}
                </button>
                <button
                    className="btn btn-primary"
                    onClick={createProject}
                    disabled={state.createProjectDisabled}
                >
                    {translate("btnProjectSend", userData.language)}
                </button>
            </div>
        </div>
    );
};

export default StepFour;
